import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './add-user-confirmation-form.scss';

/**
 * Add New User confirmation form
 * @returns JSX Element
 */
const AddUserConfirmationForm = ({ emailId, roleId }) => {
  const createUserError = useSelector((state) => state.userStore.createUserError);
  const assignRolesList = useSelector((state) => state.assignRolesList.roles);

  const [roleValue, setRoleValue] = useState(null);

  useEffect(() => {
    const role = assignRolesList.find((r) => r.id === roleId);
    setRoleValue(role?.name);
  }, [roleId, assignRolesList]);

  return <div className={'add-user-confirmation-form'}>
    <div>
      <div>
        <b>Email Address</b>
      </div>
      <p>{emailId}</p>
    </div>
    <div>
      <div>
        <b>Role</b>
      </div>
      <p>{roleValue}</p>
    </div>
    <div>
      <div>
        <b>Status</b>
      </div>
      {createUserError
        ? <div>
          <div className='add-user-confirmation-form__user-status-orb-negative-user-confirmation'></div>
          Failed
        </div>
        : <div>
          <div className='add-user-confirmation-form__user-status-orb-postive-user-confirmation'></div>
          Active
        </div>
      }
    </div>
  </div>;
};

export default AddUserConfirmationForm;
